<template>
    <div id="results" class="">
        <div class="result_item" v-for="(item, index) in results" :key="index">
            <slot v-bind:item="item">
                <div class="select icon fleft box">
                    <img
                        :src="setImageSrc(item.pid[0])"
                        :alt="setImageAlt(item.pid[0])"
                    />
                </div>
                <div class="meta fleft box">
                    <h3 class="ttl">
                        <router-link :to="setDetailLink(item.url, item.pid[0])">
                            {{ formatTitle(item.TITLE) }}
                        </router-link>
                    </h3>
                </div>
                <div class="group fleft box">
                    <!-- <p class="class"> -->
                    <div v-for="(item2, index2) in item.pid" :key="index2">
                        <span :class="setTagColor(item2)">{{
                            setTag(item2)
                        }}</span>
                        <br />
                    </div>
                    <!-- </p> -->
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { defineComponent, toRef } from "vue";

import { PidSet } from "@/store/app.config";
import store from "@/store";

export default defineComponent({
    name: "AllResultList",
    props: {
        hits: {
            type: Number,
        },
        results: {
            type: Object,
        },
        searchData: {
            type: Object,
        },
    },

    setup(props) {
        // 検索一覧結果の表示編集
        const setImageSrc = (pid) => {
            const thisPidSet = PidSet[pid] ? PidSet[pid] : PidSet.default;
            // return `/themes/custom/agrknldgtheme/common/images/icon/${thisPidSet["icon"]}`;
            return `/images/icon/${thisPidSet["icon"]}`;
        };
        const setImageAlt = (pid) => {
            const thisPidSet = PidSet[pid] ? PidSet[pid] : PidSet.default;
            return thisPidSet.alt;
        };
        const setTagColor = (pid) => {
            const thisPidSet = PidSet[pid] ? PidSet[pid] : PidSet.default;
            return thisPidSet.color;
        };
        const setTag = (pid) => {
            const thisPidSet = PidSet[pid] ? PidSet[pid] : PidSet.default;
            return thisPidSet.tagname;
        };
        const formatTitle = (title) => {
            if (!title) return "";
            if (Array.isArray(title)) {
                return title[0] || "";
            }
            return title;
        };
        const form = toRef(props, "searchData");
        const setDetailLink = (url, pid) => {
            let to_param = {};
            let url_name = "";
            if (pid == 201 || pid == 202 || pid == 203) {
                url_name = "PaperMetadata";
            } else if (pid == 401) {
                url_name = "HinshuMetadata";
            } else if (pid == 402) {
                url_name = "NoukiguMetadata";
            }
            to_param.name = url_name;
            to_param.params = {};
            if (form.value && Object.keys(form.value).length > 0) {
                Object.entries(form.value).forEach(([key, value]) => {
                    to_param.params[key] = value;
                });
            }
            // urlが配列の場合は最初の要素を使用
            const urlStr = Array.isArray(url) ? url[0] : url;
            let urlAry = urlStr.split("/");
            // urlは10桁形式（例: /RN/2010900012）なので、そのまま使用
            to_param.params.id = String(urlAry[urlAry.length - 1]);

            // 検索条件を保存
            store.commit("setParams", to_param.params);
            return to_param;
        };

        return {
            setImageSrc,
            setImageAlt,
            setTagColor,
            setTag,
            setDetailLink,
            formatTitle,
        };
    },
});
</script>

<style>
/*----------------------------------------
	results
----------------------------------------*/
.result_item {
    padding: 20px 0;
    position: relative;
    border-bottom: 1px dotted #bbbbbb;
    display: table;
    width: 100%;
}
.result_item:first-child {
    border-top: 1px dotted #bbbbbb;
}

.result_item .select {
    display: table-cell;
    vertical-align: top;
    padding-left: 10px;
    width: 35px;
}
.result_item > .inner {
    display: table-cell;
    vertical-align: top;
    padding-left: 10px;
}
.result_item .ttl {
    background: none;
    padding: 0;
    font-size: 100%;
}
.result_item .ttl a {
    text-decoration: underline;
}
.result_item .text,
.result_item .cite {
    margin-top: 10px;
    position: relative;
}
.result_item .cite li {
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
    padding-left: 11px;
    /* background: url(../images/icon_arrow_02.png) no-repeat 0 8px; */
}

.box_slidetoggle {
    display: none;
}
.result_item .box_slidetoggle {
    background-color: #f2f6f6;
    line-height: 1.5;
    margin-bottom: 10px;
    padding: 9px;
    width: 460px;
}

.result_item .group {
    display: table-cell;
    vertical-align: top;
    width: 90px;
    text-align: right;
    font-size: 92.85%;
}
.group span {
    color: #444;
    line-height: 1;
    padding: 2px;
    display: inline-block;
    border: 1px solid #ccc;
    background-color: #edf1f1;
}
.result_item .group .color_01 {
    border-color: #ce46a6;
    background-color: #fff9fe;
}
.result_item .group .color_02 {
    border-color: #4d9964;
    background-color: #f1fcf8;
}
.result_item .group .color_03 {
    border-color: #4169e1;
    background-color: #f0f8ff;
}
.result_item .group .color_04 {
    border-color: #ff8c00;
    background-color: #ffffe0;
}
.group .color_06 {
    border-color: #556b2f;
    background-color: #e0ffff;
}
.group .color_07 {
    border-color: #4d9964;
    background-color: #f1fcf8;
}
.result_item .group .color_08 {
    border-color: #4d9964;
    background-color: #f1fcf8;
}

#results .journal-table .col-issn,
#results .journal-table .col-vlyr {
    width: 16%;
}
#results .journal-table .col-publish_status_name {
    width: 10%;
}
.movepage {
    clear: both;
    padding: 20px 0;
    text-align: center;
}
.movepage li {
    display: inline;
    margin-left: 1px;
    margin-right: 1px;
    font-size: 107.14%;
}
.movepage li span,
.movepage li a {
    background: #fff none repeat scroll 0 0;
    border: 1px solid #aaa;
    display: inline-block;
    padding: 2px 9px 0;
    vertical-align: middle;
    text-decoration: underline;
}
.movepage li .current-page {
    background: #0a63bc none repeat scroll 0 0;
    color: #fff;
}
.movepage li a:hover {
    background: #f0f0f0 none repeat scroll 0 0;
}

span.org {
    background-color: #dac8c8;
    border: 1px solid #666;
    border-radius: 5px;
    color: black;
    display: block;
    float: left;
    font-weight: bold;
    padding: 1px 3px;
    text-align: center;
}
</style>
